module.exports = __webpack_public_path__ + "media/KZ-AS.b594d8c6.ogg";